import countryList from 'react-select-country-list';
import { devError } from './devLog';

export const getIndependentAssessorFormData = async (
  nominationReferee,
  organisations,
  computedFormName,
  titlesTypes = {},
) => {
  try {
    const { refereeSevenTypeId, refereeEightTypeId, refereeNineTypeId } =
      nominationReferee;
    if (
      refereeSevenTypeId === null &&
      refereeEightTypeId === null &&
      refereeNineTypeId === null
    ) {
      return null;
    }

    const createAssessorFellow = (fellowUser) =>
      fellowUser?.id ? { value: fellowUser.id, label: fellowUser.label } : null;

    const createOrganisation = (organisationId) =>
      organisationId
        ? { value: organisationId, label: organisations[organisationId] }
        : null;

    const createCountry = (countryId) =>
      countryId ? countryList().getLabel(countryId) : '';

    const getRefereeTypeId = (typeId) =>
      typeId !== 0 && typeId !== 1 ? 'none' : parseInt(typeId);

    const getNonAasLabel = (item) => {
      if (!item) return '';
      const titleName = titlesTypes[item.titleId] ? `${titlesTypes[item.titleId]} ` : '';
      return item.name
        ? `${titleName}${item.name} ${item.lastName} (${item.email})`
        : `(${item.email})`;
    };
    const prefix = computedFormName.replace('referee', '');
    const type = nominationReferee[`referee${prefix}TypeId`];
    const nonAasUser = nominationReferee[`referee${prefix}UserNonAas`] ?? null;
    const fellow = nominationReferee[`referee${prefix}UserFellow`] ?? null;
    const refData = {
      [`nonAasReferee${prefix}Id`]: {
        value: type === 0 ? nonAasUser?.id : null,
        label: type === 0 ? getNonAasLabel(nonAasUser) : null,
      },
      [`referee${prefix}`]: getRefereeTypeId(type),
      [`referee${prefix}FellowId`]: createAssessorFellow(fellow),
      [`referee${prefix}TitleId`]: nonAasUser?.titleId,
      [`referee${prefix}Name`]: nonAasUser?.name,
      [`referee${prefix}LastName`]: nonAasUser?.lastName,
      [`referee${prefix}Email`]: nonAasUser?.email,
      [`referee${prefix}OrganisationId`]: createOrganisation(
        nonAasUser?.organisationId,
      ),
      [`referee${prefix}CountryId`]: createCountry(nonAasUser?.countryId),
      [`referee${prefix}Memberships`]: nonAasUser?.memberships,
    };
    return refData;
  } catch (error) {
    devError('Error fetching data:', error);
    throw error;
  }
};
